import { Component, OnInit, ViewChildren, Output, EventEmitter, ViewChild, SimpleChanges, Input } from '@angular/core';
import { LCAAddNew, PlaceOfEmployment } from '../../../data/models/lcaaddnew.model';
import { ReferenceLibraryService } from '../../../services/referenceLibrary.service';
import { ReferenceLibrary } from '../../../data/models/referenceLibrary.model';
import { PetitionerService } from '../../../services/petitioner.service';
import { LcaService } from '../../../services/lca.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { AttorneyService } from 'src/app/services/attorney.service';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { Subject, combineLatest } from 'rxjs';
import { CountryApiService } from '../../petitioner/services/country.service';
import { takeUntil } from 'rxjs/operators';
import { acceptedFileTypes } from 'app-models';
@Component({
    selector: 'app-add-lca-new',
    templateUrl: './add-lca-new.component.html',
    styleUrls: ['./add-lca-new.component.scss'],

})

export class AddLcaNewComponent implements OnInit {
    @Input() lcaType: string;
    showDateError: boolean = true;
    lca = new LCAAddNew({
        newEmploymentCount: 0,
        continueApprovedCount: 0,
        changeApproveCount: 0,
        concurrentEmploymentCount: 0,
        employerChangeCount: 0,
        amendedPetitionCount: 0
    });
    placeOfEmployment: PlaceOfEmployment
    isCertifiedLCA: boolean;
    placeOfEmploymentInfoMaxCount: number = 3 //default max;
    visaTypeList: ReferenceLibrary[];
    listCompany: any;
    listStates = [];
    listCountry = [];
    employerInfo: any;
    petitionerInfo: any;
    lcaList: any;
    lcaId: any;
    petitionerId: any;
    showFileUploadSection: boolean = false;
    enableReadOnlyMode: boolean = false;
    expandPanel = true;
    maxDate = new Date();
    minDate: Date = new Date();
    companyListAssociatedWithAttorney = [];
    userType = '';
    @ViewChildren(MatAccordion) accordion: MatAccordion;
    @Output() enableLCAid: EventEmitter<any> = new EventEmitter();
    destroy$ = new Subject<void>();
    formChangesSubscriptions: any[] = [];
    @ViewChild('f', { static: false }) lcaForm: NgForm;

    listNaics: any[];
    listCounty0: any[];
    listCounty1: any[];
    listCounty2: any[];
    wageResults: any[] = [];
    wageResultsEducation: any[] = [];


    configurations = {
        inputMultipleFlag: false,
        fileType: acceptedFileTypes,
        isFileListRequired: true,
        categoryName: 'LCADOC',
        entityId: 0,
        fileCategory: 'LCA',
        listUploadedFiles: [],
        documentTypeRequired: true,
        docummentTypeCode: 'LCADOC',
        useCase: 'company',
        useCaseId: parseInt(sessionStorage.getItem('companyId'))
    };
    isSaveAsDraftDisabled: boolean = true;
    @Input() extractedLCADetails: any;
    isDuplicateLCA: boolean = false;

    constructor(private router: Router, private route: ActivatedRoute,
        private referenceLibraryService: ReferenceLibraryService,
        private petitionerService: PetitionerService,
        private toastr: ToastrService,
        private lcaApis: LcaService,
        private attorneyService: AttorneyService,
        private apiService: CountryApiService,
        protected store: Store<any>) {
        this.lca.placeOfEmployments = [this.placeOfEmploymentInfo()];
        this.visaTypeList = [];
    }

    ngOnInit() {
        this.onChangeCountry('USA');

        this.userType = sessionStorage.getItem('userTypeRole');
        this.referenceLibraryService.getReferenceData('VISATYP').subscribe((response: ReferenceLibrary[]) => {
            this.visaTypeList = response && response.filter(ele => (ele.code === 'H1-B' || ele.code === 'E3'));
            if (this.employerInfo) {
                this.employerInfo.feiNo = '';  // temp error correction 
                this.employerInfo.naicsCode = ''; // temp error correction 
            }
        });
        this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';
        if (sessionStorage.getItem('companyId')) {
            if (this.userType === 'Attorney') {
                this.getCompanyListAssociatedWithAttorney()
                this.lca.id = sessionStorage.getItem('lcaId') ? parseInt(sessionStorage.getItem('lcaId')) : null;
            } else {
                this.lcaApis.companyHierarchy(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
                    if (data) {
                        this.lcaApis.getCompanyNaics(parseInt(sessionStorage.getItem('companyId'))).subscribe(response => {
                            if (response == null) {
                                this.listNaics = [];
                            } else {
                                this.listNaics = response;
                                this.mappNaicsCode();
                            }
                            // this.listNaics = [{naicsCode: '564654', naicsTitle: '564654'},{naicsCode: '66666', naicsTitle: '66666'},{naicsCode: '77777', naicsTitle: '77777'}];

                            this.listCompany = data;
                            if (this.lca.companyId) {
                                this.employerInfo = this.listCompany.find(x => x.id === this.lca.companyId);
                            }
                            else {
                                this.employerInfo = data[0];
                                this.lca.companyId = data[0].id;
                            }

                            this.listNaics.forEach((item) => {
                                if (item.naicsCode === this.employerInfo.naicsCode) {
                                    this.lca.companyNaicsCode = item.naicsCode;
                                }
                            });

                            this.lca.id = sessionStorage.getItem('lcaId') ? parseInt(sessionStorage.getItem('lcaId')) : null;
                        })
                    }


                });

            }
            this.getInputField()
        }

        if (sessionStorage.getItem('lcaId')) {
            this.getLcaData();
        }
        // this.getInputField()
    }

    getLcaData() {
        this.petitionerService.getLcaDetailsById(parseInt(sessionStorage.getItem('lcaId'))).subscribe(data => {
            this.configurations.entityId = parseInt(sessionStorage.getItem('lcaId'));
            this.configurations = Object.assign({}, this.configurations);

            data.lcaApplication['companyId'] = data.lcaApplication?.company?.id;
            data.lcaApplication.visaType = data.lcaApplication?.visaType?.code;
            // var socCode = data.lcaApplication.socCode;
            this.lca.socCode = data.lcaApplication?.socCode;
            // console.log('only edit', this.lca.socCode)
            this.lca = data['lcaApplication'];
            this.lca.placeOfEmployments = data['placeList']?.length > 0 ? data['placeList'] : [this.placeOfEmploymentInfo()];
            this.lca.employmentStartDate = this.lca.employmentStartDate ? moment(this.lca.employmentStartDate).toISOString() : '';
            this.lca.employmentEndDate = this.lca.employmentEndDate ? moment(this.lca.employmentEndDate).toISOString() : '';
            this.lca.lcaAppliedDate = this.lca.lcaAppliedDate ? moment(this.lca.lcaAppliedDate).toISOString() : '';
            this.lca.certifiedDate = this.lca.certifiedDate ? moment(this.lca.certifiedDate).toISOString() : '';
            this.lca.workforceNotifiedDate = this.lca.workforceNotifiedDate ? moment(this.lca.workforceNotifiedDate).toISOString() : '';
            if (this.lca['statusChangeDate']) {
                this.lca['statusChangeDate'] = moment(this.lca['statusChangeDate']).format('YYYY-MM-DD');
            }
            if (this.lca['status'] && this.lca['status']['code'] !== "LCAASSIGN") {
                this.enableReadOnlyMode = false;
                // this.onChangeOccupationTitle(data.lcaApplication.socCode)
            } else {
                this.enableReadOnlyMode = true;
                // this.onChangeOccupationTitle(data.lcaApplication.socCode)
            }
            this.lca.placeOfEmployments.forEach((item, index) => {
                this.onChangeState(item.addressDTO.stateProvinceCode, index);
                this.getWageLevels(index, item.addressDTO.county, item.addressDTO.stateProvinceCode, this.lca.socCode);
                // this.onChangeState('CA', index); 
            })
            this.enableLCAid.emit(this.lca);

        });
    }

    ngOnChanges(changes: SimpleChanges) {
        // console.log(changes);
        if ((changes?.extractedLCADetails?.currentValue && Object.keys(changes?.extractedLCADetails?.currentValue).length > 0) || changes['lcaType']) {

            this.lca.isCertifiedLCA = (this.extractedLCADetails?.us_gov_agency_use?.caseStatus === 'Certified') ? true : false;
            this.lca.caseNumber = this.extractedLCADetails?.us_gov_agency_use?.caseNumber || null;
            this.lca.lcaAppliedDate = (this.extractedLCADetails?.us_gov_agency_use?.lcaAppliedDate) ? moment(this.extractedLCADetails.us_gov_agency_use.lcaAppliedDate).toISOString() : '';
            this.lca.certifiedDate = (this.extractedLCADetails?.us_gov_agency_use?.certificationDate) ? moment(this.extractedLCADetails.us_gov_agency_use.certificationDate).toISOString() : '';

            this.lca.visaType = this.extractedLCADetails?.visaType?.code || '';
            this.lca.jobTitle = this.extractedLCADetails?.lcaDetails?.jobTitle || '';
            this.lca.socCode = this.extractedLCADetails?.lcaDetails?.socCode || '';
            this.lca.socTitle = this.extractedLCADetails?.lcaDetails?.socTitle || '';
            this.lca.isFullTime = (this.extractedLCADetails?.lcaDetails?.isFullTime === "Yes") ? true : false;
            this.lca.employmentStartDate = (this.extractedLCADetails?.lcaDetails?.employmentStartDate) ? moment(this.extractedLCADetails.lcaDetails.employmentStartDate).toISOString() : '';
            this.lca.employmentEndDate = (this.extractedLCADetails?.lcaDetails?.employmentEndDate) ? moment(this.extractedLCADetails.lcaDetails.employmentEndDate).toISOString() : '';
            this.lca.totalCount = this.extractedLCADetails?.lcaDetails?.availableCount || 0;
            this.lca.newEmploymentCount = this.extractedLCADetails?.lcaDetails?.newEmploymentCount || 0;
            this.lca.continueApprovedCount = this.extractedLCADetails?.lcaDetails?.continueApprovedCount || 0;
            this.lca.changeApproveCount = this.extractedLCADetails?.lcaDetails?.changeApproveCount || 0;
            this.lca.concurrentEmploymentCount = this.extractedLCADetails?.lcaDetails?.concurrentEmploymentCount || 0;
            this.lca.employerChangeCount = this.extractedLCADetails?.lcaDetails?.employerChangeCount || 0;
            this.lca.amendedPetitionCount = this.extractedLCADetails?.lcaDetails?.amendedPetitionCount || 0;

            //this.lca.companyNaicsCode = this.extractedLCADetails?.employer_info?.naicsCode || '';
            let addressObj = {
                addressLine1: this.extractedLCADetails?.employment_wage_info?.addressLine1 || '',
                addressLine2: this.extractedLCADetails?.employment_wage_info?.addressLine2 || '',
                city: this.extractedLCADetails?.employment_wage_info?.city || '',
                county: this.extractedLCADetails?.employment_wage_info?.county || '',
                stateProvinceName: this.extractedLCADetails?.employment_wage_info?.state || '',
                postalCode: this.extractedLCADetails?.employment_wage_info?.postalCode || '',
                addressTypeCode: 'WORK',
                id: 0,
                stateProvinceCode: (this.extractedLCADetails?.employment_wage_info?.state) ? this.listStates.find(st => st.stateProvinceName === this.extractedLCADetails.employment_wage_info.state).stateProvinceCode : ''
            }
            this.lca.placeOfEmployments[0] = {
                addressDTO: addressObj,
                wageRangeFrom: this.extractedLCADetails?.employment_wage_info?.wage_details?.wageRangeFrom,
                wageRangeTo: this.extractedLCADetails?.employment_wage_info?.wage_details?.wageRangeTo,
                wageRangeTypeCode: this.extractedLCADetails?.employment_wage_info?.wage_details?.wageRangeTypeCode,
                prvlWageRate: this.extractedLCADetails?.employment_wage_info?.prevailing_wage?.prvlWageRate,
                prvWageTypeCode: this.extractedLCADetails?.employment_wage_info?.prevailing_wage?.prvWageTypeCode,
                prvWageLevelTypeCode: this.extractedLCADetails?.employment_wage_info?.prevailing_wage?.prvWageLevelTypeCode,
                sequenceNo: 0,
                id: 0,
                lcaCodeId: null,
                countyAreaName: this.extractedLCADetails?.employment_wage_info?.countyAreaName
            }
            if (this.lca.placeOfEmployments[0].addressDTO.stateProvinceCode && this.lca.placeOfEmployments[0].addressDTO.county) {
                this.onChangeState(this.lca.placeOfEmployments[0].addressDTO.stateProvinceCode, 0);
                this.getWageLevels(0, this.lca.placeOfEmployments[0].addressDTO.county, this.lca.placeOfEmployments[0].addressDTO.stateProvinceCode, this.lca.socCode)
            }
        }
    }

    ngAfterViewInit() {
        this.formChangesSubscriptions[0] = this.lcaForm.statusChanges.subscribe(() => {
            if (this.lcaForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.formChangesSubscriptions[1] = this.lcaForm.valueChanges.subscribe((formValue) => {
            this.isSaveAsDraftDisabled = !Object.values(formValue).some((val) => !!val || val === 0);
        });

    }

    selectedCompany(id) {
        this.lcaApis.getCompanyNaics(id).subscribe(response => {

            if (response == null) {
                this.listNaics = [];
            } else {
                this.listNaics = response;
                this.mappNaicsCode();
            }
            // this.listNaics = [{naicsCode: 1, naicsTitle: 'aaa'},{naicsCode: 2, naicsTitle: 'bbb'},{naicsCode: 3, naicsTitle: 'ccc'}];

            if (this.userType === 'Attorney') {
                this.petitionerInfo = this.companyListAssociatedWithAttorney.find(x => x.petitionerId === parseInt(id));
                this.lca.companyId = id;

                this.listNaics.forEach((item) => {
                    if (item.naicsCode === this.petitionerInfo.naicsCode) {
                        this.lca.companyNaicsCode = item.naicsCode;
                    }
                });

            } else {
                this.employerInfo = this.listCompany.find(x => x.id === parseInt(id));
                this.lca.companyId = id;

                this.listNaics.forEach((item) => {
                    if (item.naicsCode === this.employerInfo.naicsCode) {
                        this.lca.companyNaicsCode = item.naicsCode;
                    }
                });

            }

            this.expandPanel = true;
        });
    }

    selectedNaics(id) {
        //console.log('iddd', id);
    }

    getCompanyListAssociatedWithAttorney() {
        const reqJson = {
            searchText: '',
            searchCriteria: '',
            sortBy: '',
            sortOrder: '',
            pageNumber: 0,
            recordsPerPage: 0
        };

        this.attorneyService.getClientsList(parseInt(sessionStorage.getItem('companyId')), reqJson).subscribe((response: any) => {
            if (response) {
                this.lcaApis.getCompanyNaics(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
                    if (data == null) {
                        this.listNaics = [];
                    } else {
                        this.listNaics = data;
                        this.mappNaicsCode();
                    }

                    // this.listNaics = [{naicsCode: 1, naicsTitle: 'aaa'},{naicsCode: 2, naicsTitle: 'bbb'},{naicsCode: 3, naicsTitle: 'ccc'}];

                    this.companyListAssociatedWithAttorney = response['petetionerList'];
                    if (this.lca.companyId) {
                        //this.petitionerInfo = this.companyListAssociatedWithAttorney.find(x => x.petitionerId === this.lca.companyId);
                        this.selectedCompany(this.lca.companyId);

                    } else {
                        this.petitionerInfo = this.companyListAssociatedWithAttorney[0];
                        this.lca.companyId = this.companyListAssociatedWithAttorney[0].petitionerId;
                        //load NAICS codes for first company
                        this.naicsCodes(this.lca.companyId);
                    }
                })
            }
        });
    }

    naicsCodes(companyId: number | null) {
        this.lcaApis.getCompanyNaics(companyId).subscribe(data => {
            this.listNaics = data ? data : [];
            this.listNaics.forEach((item) => {
                if (item.naicsCode === this.petitionerInfo?.naicsCode) {
                    this.lca.companyNaicsCode = item.naicsCode;
                }
            });
            this.mappNaicsCode();
        })
    }

    mappNaicsCode() {
        this.listNaics.forEach((item) => {
            item.naicsTitle = item.naicsCode + "--" + item.naicsTitle
        })
    }

    lcaAddNewFormSub(f: NgForm, isDraft: boolean = false) {
        if (f.invalid && !isDraft) {
            return false; // invalid form  returning here
        }
        this.lca.onetSocVer = this.lca.onetSocVer;
        //('this.onetSocVer', this.lca.onetSocVer)
        this.lca.isFullTime = this.lca.isFullTime ? true : false;
        this.lca.newEmploymentCount = +(this.lca.newEmploymentCount) ? Number(this.lca.newEmploymentCount) : 0;
        this.lca.continueApprovedCount = +(this.lca.continueApprovedCount) ? Number(this.lca.continueApprovedCount) : 0;
        this.lca.changeApproveCount = +(this.lca.changeApproveCount) ? Number(this.lca.changeApproveCount) : 0;
        this.lca.concurrentEmploymentCount = +(this.lca.concurrentEmploymentCount) ? Number(this.lca.concurrentEmploymentCount) : 0;
        this.lca.employerChangeCount = +(this.lca.employerChangeCount) ? Number(this.lca.employerChangeCount) : 0;
        this.lca.amendedPetitionCount = +(this.lca.amendedPetitionCount) ? Number(this.lca.amendedPetitionCount) : 0;
        this.lca.totalCount = +(this.lca.totalCount) ? Number(this.lca.totalCount) : 0;
        this.lca.employmentStartDate = this.lca.employmentStartDate ? moment(this.lca.employmentStartDate).format('YYYY-MM-DD') : '';
        this.lca.employmentEndDate = this.lca.employmentEndDate ? moment(this.lca.employmentEndDate).format('YYYY-MM-DD') : '';
        this.lca.lcaAppliedDate = this.lca.lcaAppliedDate ? moment(this.lca.lcaAppliedDate).format('YYYY-MM-DD') : '';
        this.lca.certifiedDate = this.lca.certifiedDate ? moment(this.lca.certifiedDate).format('YYYY-MM-DD') : '';
        // this.lca.id = this.lca.id || null;

        this.lca.id = this.isDuplicateLCA ? null : this.lca.id || null;
        this.lca.isCertifiedLCA = this.lca.isCertifiedLCA || null;
        if (this.lcaType == 'filedLCA') {
            this.lca.lcaFiledType = 'Ext-Filed';
        } else if (this.lcaType == 'certifiedLCA') {
            this.lca.lcaFiledType = 'Ext-Certified';
        } else {
            this.lca.lcaFiledType = 'E-Filed';
        }

        if (this.lca.companyNaicsCode) {
            let selectedItem;
            this.listNaics.forEach((item) => {
                if (item.naicsCode === this.lca.companyNaicsCode) {
                    selectedItem = item;
                }
            });
            this.lca.companyNaicsCode = selectedItem.naicsCode;
            this.lca.companyNaicsTitle = selectedItem.naicsTitle.substring(selectedItem.naicsTitle.indexOf("--") + 2);
        } else {
            this.lca.companyNaicsCode = null;
            this.lca.companyNaicsTitle = null;
        }

        this.lcaApis.createLCA({ isSaveAsDraft: isDraft, ...this.lca }).subscribe(response => {
            if (response['status'] === 200) {
                this.showFileUploadSection = true;
                this.lca.id = response['data'];
                if (this.lca.id) {
                    sessionStorage.setItem('lcaId', response['data'])
                    this.getLcaData();
                }
                //  this.enableLCAid.emit(this.lca);
                this.configurations.entityId = response['data'];
                this.configurations = Object.assign({}, this.configurations);
                this.lcaForm.reset(this.lcaForm.value);
                this.toastr.success(response['message'], 'Success');
            } else {
                //this.toastr.error('', response['message']);
                this.showFileUploadSection = false;
            }
        });
    }

    backToLCAList() {
        this.router.navigate(['../lca'], { relativeTo: this.route });
    }

    enableEditMode() {
        this.enableReadOnlyMode = false;
    }

    toggleExpansion() {
        this.expandPanel = !this.expandPanel;
    }

    getGlobalErrorMessages(error: string) {
        return errorUtils.errorMessages.get(error);
    }

    handlePlaceOfEmptInfoCount(mode) {
        if (mode == -1) {
            this.lca.placeOfEmployments.length > 1 ? this.lca.placeOfEmployments.pop() : '';
        }
        else {
            this.lca.placeOfEmployments.length < 3 ? this.lca.placeOfEmployments.push(this.placeOfEmploymentInfo()) : '';
        }
    }

    placeOfEmploymentInfo() {
        let len = (this.lca.placeOfEmployments || []).length;
        let seqId = len > 0 ? len + 1 : 1;
        return {
            addressDTO: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                county: '',
                stateProvinceName: '',
                postalCode: '',
                addressTypeCode: 'WORK',
                id: 0,
                stateProvinceCode: '',
            },
            wageRangeFrom: 0,
            wageRangeTo: 0,
            wageRangeTypeCode: '',
            prvlWageRate: 0,
            prvWageTypeCode: '',
            prvWageLevelTypeCode: '',
            sequenceNo: seqId,
            id: 0,
            lcaCodeId: null,
        }
    }

    ngOnDestroy() {
        if (this.formChangesSubscriptions) {
            this.formChangesSubscriptions.forEach(subscription => subscription.unsubscribe());
        }
        this.destroy$.next();
        this.destroy$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }

    socCodeList: any;
    socCodeListFiltered: any;

    getInputField() {
        this.lcaApis.getDataFromService(false).subscribe((res: any) => {
            this.socCodeList = res.data
            this.socCodeListFiltered = this.socCodeList
            //  console.log('getDataFromService true',res)
        });
    }



    onKey(value) {
        // console.log('valuevaluevalue',value.toString())
        //  console.log('this.lca.socCode',this.lca.socCode)
        if (value.length > 2) {
            // this.socCodeListFiltered  = this.socCodeList.filter((item)=>item.socCode === value.toString())
            this.lcaApis.getDatagetSocCodeList(false, value.toString()).subscribe((res: any) => {
                if (res) {
                    this.socCodeListFiltered = res.data;
                    // console.log('socCodeListFiltered',res)
                }
                // else{
                //   console.log('socCodeListFiltered',res)
                //   this.socCodeListFiltered = ''
                // }
                //this.socCodeListFiltered =  this.socCodeList
            });
        }

    }

    searchSoc: any;
    version: any;
    enableReadOnlyModes: boolean = true;
    onChangeOccupationTitle(id) {
        var socTitle = this.socCodeList.filter((item) => item.socCode === id)[0].title;
        var version = this.socCodeList.filter((item) => item.socCode === id)[0].version;
        //this.lca.socCode = id.socCode;
        this.lca.onetSocVer = version;
        this.lca.socTitle = socTitle;
    }

    getListSocCOde() {
        // console.log('this.searchSoc' )       
        this.socCodeListFiltered = this.socCodeList
    }

    onChangeCountry(countryCode: string) {
        this.apiService.getStates(countryCode)
            .pipe(takeUntil(this.destroy$))
            .subscribe((states: []) => {
                this.listStates = states;
            });
    }

    onChangeState(stateCode: string, index: any) {
        this.apiService.getCounties(stateCode)
            .pipe(takeUntil(this.destroy$))
            .subscribe((county: []) => {
                if (index === 0) {
                    this.listCounty0 = county;
                } else if (index === 1) {
                    this.listCounty1 = county;
                } else if (index === 2) {
                    this.listCounty2 = county;
                }
            });
    }

    onChangeVisa() {
        if (this.lca.visaType) {
            this.onChangeEndDate();
        }
    }

    getWageLevels(index, event, state, socCode) {
        let countyName = '';
        if (event.value) {
            countyName = event.value;
        } else {
            countyName = event;
        }
        let stateName = this.listStates.filter(eachState => eachState.stateProvinceCode === state).map(eachState => eachState.stateProvinceName);
        if (stateName && countyName.length > 0 && socCode) {
            const reqArr = [this.lcaApis.getWagesOfLevels(socCode, stateName, countyName), this.lcaApis.getWagesOfLevels(socCode, stateName, countyName, true)];
            combineLatest(reqArr)
                .pipe(takeUntil(this.destroy$))
                .subscribe((response: any[]) => {
                    if (response[0]?.data) {
                        if (!this.wageResults[index]) {
                            this.wageResults.push(response[0].data[0]);
                        } else {
                            this.wageResults[index] = response[0].data[0];
                        }
                    }
                    if (response[1]?.data) {
                        if (!this.wageResultsEducation[index]) {
                            this.wageResultsEducation.push(response[1].data[0]);
                        } else {
                            this.wageResultsEducation[index] = response[1].data[0];
                        }
                    }
                });
        }
    }

    onChangeEndDate() {
        if (this.lca.employmentStartDate && this.lca.employmentEndDate) {
            let diffYear = (moment(this.lca.employmentEndDate).toDate().getTime() - moment(this.lca.employmentStartDate).toDate().getTime()) / 1000;
            diffYear /= (60 * 60 * 24);
            let diffResult = diffYear / 365;

            switch (this.lca.visaType) {
                case 'H1-B':
                    this.showDateError = diffResult <= 3;
                    break;
                case 'H1-B1':
                    this.showDateError = diffResult <= 3;
                    break;
                case 'E3':
                    this.showDateError = diffResult <= 2;
                    break;
                case 'default':
                    break;
            }
        }
    }

    saveAsDraft(event) {
        this.lcaAddNewFormSub(this.lcaForm, event);
    }
}


